import * as React from 'react';
import { GridColumn as GridColumnCore, } from '@core-front/grid';
function getWidth(width) {
    return width.filter((e) => !e.endsWith('-xxl') && e !== 'xxl' && !e.startsWith('xxl-'));
}
function getOffset(offset) {
    return offset.filter((e) => !e.startsWith('xxl-'));
}
function getOrder(order) {
    return order.filter((e) => !e.endsWith('-xxl'));
}
function getBorder(border) {
    return border.filter((e) => !e.endsWith('-xxl'));
}
function getAlign(align) {
    return align.filter((e) => !e.endsWith('-xxl'));
}
const GridColumn = (props) => {
    const { offset, width, order, border, align, className } = props;
    function BEM() {
        const classArray = [];
        function pushToArray(array, prefix) {
            classArray.push(...array.filter(i => i.includes('xxl')).map(i => prefix + i));
        }
        if (width) {
            pushToArray(width, 'grid__col--');
        }
        if (offset) {
            pushToArray(offset, 'grid__col--offset-');
        }
        if (order) {
            pushToArray(order, 'grid__col--');
        }
        if (align) {
            pushToArray(align, 'grid__col--');
        }
        if (border) {
            pushToArray(border, 'grid__col--border-');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (React.createElement(GridColumnCore, Object.assign({}, props, { className: BEM(), width: width && getWidth(width), offset: offset && getOffset(offset), order: order && getOrder(order), border: border && getBorder(border), align: align && getAlign(align) })));
};
export { GridColumn as default, };
